/**
 * Single source of truth for the SDK version.
 */
export const SDK_VERSION = '1.6.6';
